<template>
  <div>
    <h4 class="ui dividing header">{{ $t("search criteria") }}</h4>
    <div class="ui form">
      <div class="fields">
        <div class="six column wide field">
          <label>{{ $t("start date") }}</label>
          <div class="ui calendar" ref="range_start">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" :placeholder="$t('start date')" />
            </div>
          </div>
        </div>
        <div class="six column wide field">
          <label>{{ $t("end date") }}</label>
          <div class="ui calendar" ref="range_end">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" :placeholder="$t('end date')" />
            </div>
          </div>
        </div>
        <div class="four column wide field">
          <label for>{{ $t("search") }}</label>
          <div class="ui blue icon labeled fluid button" @click="search">
            <i class="find icon"></i>
            {{ $t("search") }}
          </div>
        </div>
      </div>
    </div>

    <h4 class="ui dividing header">{{ $t("log") }}</h4>
    <table class="ui celled selectable striped table" ref="table">
      <thead>
        <tr>
          <th>{{ $t("registered") }}</th>
          <th>{{ $t("activity") }}</th>
          <th>{{ $t("error") }}</th>
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!items.length">
          <td colspan="4" style="text-align: center">{{ $t("no results") }}</td>
        </tr>
        <tr v-for="(item, idx) in items" :key="idx">
          <td>
            {{
              item.create_date
                | formatDate(enterprise_setup.detailed_date_format)
            }}
          </td>
          <td>
            <i :class="activity(item.ngn_interaction).icon"></i>
            {{ activity(item.ngn_interaction).name }}
          </td>
          <td>{{ item.error }}</td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import "datatables.net";
import "datatables.net-se";
import { local_api, error_toast, enterprise_setup } from "@/utils";
import filters from "@/filters";
import moment from "moment";

export default {
  name: "InstanceTracker",
  filters: filters,
  props: { process: Object },
  data() {
    return {
      start_date: "",
      end_date: "",
      items: [],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  mounted() {
    let vm = this;

    window.jQuery(vm.$refs.range_start).calendar({
      today: true,
      type: "date",
      endCalendar: window.jQuery(vm.$refs.range_end),
      onSelect(value) {
        vm.start_date = value;
      },
    });
    window.jQuery(vm.$refs.range_end).calendar({
      today: true,
      type: "date",
      startCalendar: window.jQuery(vm.$refs.range_start),
      onSelect(value) {
        vm.end_date = value;
      },
    });

    let now = moment().toISOString();
    let start_of_day = moment().startOf("day").toISOString();
    console.log(start_of_day, now);

    setTimeout(() => {
      window.jQuery(vm.$refs.range_start).calendar("set date", start_of_day);
      window.jQuery(vm.$refs.range_end).calendar("set date", now);
      vm.start_date = start_of_day;
      vm.end_date = now;
    }, 200);
  },
  methods: {
    search() {
      let vm = this;
      local_api(vm, "post", "/ngine_core/instance/do-get-errors", {
        i: vm.process.uuid,
        s: vm.start_date,
        e: vm.end_date,
      })
        .then((instances) => {
          vm.items = instances;
          // window.jQuery(vm.$refs.table).DataTable();
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    activity(interaction) {
      console.log(interaction);
      if (!interaction) return { name: "-", icon: "asterisk icon" };
      let component = JSON.parse(interaction.component);

      if (component.$type == "bpmn:UserTask")
        return {
          name: component.name || interaction.component_name,
          icon: "user icon",
        };
      else if (component.$type == "bpmn:StartEvent")
        return {
          name: component.name || interaction.component_name,
          icon: "bullseye icon",
        };
      else if (component.$type == "bpmn:SequenceFlow")
        return {
          name: component.name || interaction.component_name,
          icon: "right arrow icon",
        };
      else if (component.$type == "bpmn:EndEvent")
        return {
          name: component.name || interaction.component_name,
          icon: "flag checkered icon",
        };
      else if (component.$type == "bpmn:ServiceTask") {
        return {
          name: component.name || interaction.component_name,
          icon: "cogs icon",
        };
      } else return { name: "?", icon: "question mark icon" };
    },
  },
};
</script>
